/* Maşinga: küçük açılır menüyü, ait olduğu başlığın tam altına hizalar. */
(function () {
  function place(li) {
    var sub = li.querySelector(':scope > .menu-list__submenu');
    if (!sub) return;
    var row = sub.offsetParent || li.closest('.header__row');
    if (!row) return;
    var left = li.getBoundingClientRect().left - row.getBoundingClientRect().left;
    var max = row.clientWidth - sub.offsetWidth - 8;
    if (max > 0 && left > max) left = max;
    sub.style.setProperty('--ms-dd-left', Math.max(0, left) + 'px');
  }
  function placeAll() {
    document.querySelectorAll('.header-menu .menu-list__list-item:not([slot])').forEach(place);
  }
  document.addEventListener('pointerover', function (e) {
    var li = e.target.closest && e.target.closest('.header-menu .menu-list__list-item:not([slot])');
    if (li) place(li);
  });
  document.addEventListener('focusin', function (e) {
    var li = e.target.closest && e.target.closest('.header-menu .menu-list__list-item:not([slot])');
    if (li) place(li);
  });
  window.addEventListener('resize', placeAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeAll);
  else placeAll();
})();
